import wx from 'weixin-js-sdk'
import { getWxConfig } from '@/request/api'
import { inApp } from '@/config'

// 设置点击右上角分享的数据
export const setShareData = (shareParams = {}) => {
  // App之外（微信）环境中使用
  if (inApp()) {
    return
  }
  getConfig((success = false) => {
    if (!success) {
      return
    }
    wx.ready(function () {
      wx.updateTimelineShareData(shareParams)
      wx.updateAppMessageShareData(shareParams)
      wx.onMenuShareAppMessage(shareParams)
      wx.onMenuShareTimeline(shareParams)
    })
  })
}

// 接口获取微信配置
const getConfig = (callback) => {
  getWxConfig({
    inputUrl: window.location.href.split('#')[0]
  })
    .then(res => {
      const { code = 1, data = {} } = res || {}
      if (code === 200) {
        setWxConfig(data, callback)
        return
      }
      callback && callback(false)
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log(e)
      callback && callback(false)
    })
}

// 设置微信js-sdk配置
const setWxConfig = (data, callback) => {
  const {
    wxInfoMap: {
      appId = '',
      nonceStr = '',
      signature = '',
      timestamp = '',
    } = {}
  } = data || {}
  const config = {
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: appId, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: nonceStr, // 必填，生成签名的随机串
    signature: signature,// 必填，签名，见附录1
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline']
  }
  wx.config(config)
  callback && callback(true)
}
